import { Dinero, dinero, maximum, minimum, toDecimal, toSnapshot } from 'dinero.js';
import { USD } from '@dinero.js/currencies';

export type  Money          = Dinero<number>;
export const cents          = ( centsValue:   number           ) => dinero( { amount: centsValue, currency: USD } );
export const toCents        = ( money:        Dinero<number>   ) => toSnapshot( money ).amount;
export const min            = ( monies:       Dinero<number>[] ) => minimum( monies );
export const max            = ( monies:       Dinero<number>[] ) => maximum( monies );
/**
 * @deprecated.  Use ShowMoney
 * @param money 
 * @returns showMoney currency format with cents
 */
export const showMoneyShort = ( money:        Dinero<number>   ) => showMoney( money );
export const showMoney      = ( money:        Dinero<number>   ) => commas( `$${toDecimal( money )}` );
export const showMoneyWithCents = (amountInCents: number): string => {
  const money = dinero({ amount: amountInCents, currency: USD });
  const decimal = Number(toDecimal(money));
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(decimal);
};

//str is a string of the format \d+\.\d\d
function commas( str: string ) {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
